import {
  addCommentSupportTicketAsync,
  createSupportTicketAsync,
  getCommentsSupportTicketAsync,
  getSupportTicketAsync
} from './SupportTickets.requests';

import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { RootState } from '../../app/store';

export const getSupportTicket = createAsyncThunk(
  'getSupportTicket',
  async () => {
    const { data } = await getSupportTicketAsync();
    return data;
  }
);

// ✅ Create Support Ticket with File Uploads
export const createSupportTicket = createAsyncThunk(
  'createSupportTicket',
  async (formData: FormData) => {
    const { data } = await createSupportTicketAsync(formData);
    return data;
  }
);

export const getCommentsSupportTicket = createAsyncThunk(
  'getCommentsSupportTicket',
  async (ticketId: number, { getState }) => {
    const { data } = await getCommentsSupportTicketAsync(ticketId);

    const state = getState() as RootState;

    const tickets = state.supportTickets.tickets;

    console.log(tickets);

    const ticket = tickets.filter((t) => t.id === Number(ticketId))[0];

    return { ticket, comments: data };
  }
);

export const addCommentSupportTicket = createAsyncThunk(
  'addCommentSupportTicket',
  async ({
    id,
    formData,
    images
  }: {
    id: number;
    formData: FormData;
    images: File[];
  }) => {
    const { data } = await addCommentSupportTicketAsync(id, formData);

    // ✅ Ensure `message` is a string
    const message = String(formData.get('message') || '');

    // ✅ Ensure attachments have correct structure
    const attachments = images.map((image: File) => ({
      contentUrl: URL.createObjectURL(image), // Simulate uploaded URL
      thumbnailUrl: URL.createObjectURL(image) // Simulate thumbnail
    }));

    return {
      message,
      isUser: true,
      id: 0,
      dateCreated: moment().toISOString(),
      attachments
    };
  }
);
